module.exports = __webpack_public_path__ + "img/8e0de5d.jpg";